import React, { useEffect, useState } from "react";
import { Icon } from "semantic-ui-react";
import "./darkMode.css";

const STORAGE_KEY = "openmhz-dark-mode";

function getInitialDarkMode() {
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored !== null) {
    return stored === "true";
  }
  // Dark mode by default for first-time visitors, regardless of OS preference.
  return true;
}

const DarkModeToggle = () => {
  const [dark, setDark] = useState(getInitialDarkMode);

  useEffect(() => {
    document.body.classList.toggle("dark-mode", dark);
    window.localStorage.setItem(STORAGE_KEY, dark);
  }, [dark]);

  return (
    <div
      className="dark-mode-toggle"
      onClick={() => setDark((d) => !d)}
      title={dark ? "Switch to light mode" : "Switch to dark mode"}
    >
      <Icon name={dark ? "sun" : "moon"} size="large" />
    </div>
  );
};

export default DarkModeToggle;
